<!-- Top control panel -->
<app-cartcontrol [cartName]="datacartName" (onDownloadSelected)="downloadSelectedFiles($event)"
                 (onRemoveSelected)="removeSelectedFiles($event)"
                 (onRemoveDownloaded)="remvoeDownloadedFiles($event)">
</app-cartcontrol>

<!-- Bundle plan -->
<app-bundleplan #bundler [cartName]="datacartName" 
                (outputOverallStatus)="updateCartOperationalStatus($event)">
</app-bundleplan>

<!-- Tree table -->
<app-treetable *ngIf="isCartLoadedSuccessfully" [cartName]="datacartName" [forceReload]="forceReload"></app-treetable>

<div *ngIf="errorMessage" class="alert alert-danger unavailabe-error-message">
    <i class="faa faa-exclamation-triangle" style="margin-right: 5px;"></i>
    {{ errorMessage }}
</div>
